/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Per_NightInputs */

const en_rental_per_night = /** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ night`)
};

const es_rental_per_night = /** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ noche`)
};

const fr_rental_per_night = /** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ nuit`)
};

const de_rental_per_night = /** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ Nacht`)
};

const id_rental_per_night = /** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ malam`)
};

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const ja_rental_per_night = en_rental_per_night;

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const zh_rental_per_night = en_rental_per_night;

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const ar_rental_per_night = en_rental_per_night;

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const it_rental_per_night = en_rental_per_night;

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const ru_rental_per_night = en_rental_per_night;

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const pt_rental_per_night = en_rental_per_night;

/** @type {(inputs: Rental_Per_NightInputs) => LocalizedString} */
const ko_rental_per_night = en_rental_per_night;

/**
* | output |
* | --- |
* | "/ night" |
*
* @param {Rental_Per_NightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_per_night = /** @type {((inputs?: Rental_Per_NightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Per_NightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_per_night(inputs)
	if (locale === "es") return es_rental_per_night(inputs)
	if (locale === "fr") return fr_rental_per_night(inputs)
	if (locale === "de") return de_rental_per_night(inputs)
	if (locale === "ja") return ja_rental_per_night(inputs)
	if (locale === "zh") return zh_rental_per_night(inputs)
	if (locale === "ar") return ar_rental_per_night(inputs)
	if (locale === "id") return id_rental_per_night(inputs)
	if (locale === "it") return it_rental_per_night(inputs)
	if (locale === "ru") return ru_rental_per_night(inputs)
	if (locale === "pt") return pt_rental_per_night(inputs)
	return ko_rental_per_night(inputs)
});